export const BUTTON_LINK_TYPE = 'button';
export const BUTTON_LINK_VARIANT = 'primary';
export const BUTTON_LINK_SIZE = 'large';
export const OVERLAY_OPEN_TIMEOUT = 0;
export const OVERLAY_CLOSE_TIMEOUT = 600;
